import React, { useState, useEffect, useRef } from 'react';
import { TextField } from '@mui/material';

export const DebouncedInput = React.memo(({ value: externalValue, onCommit, ...props }) => {
  const [local, setLocal] = useState(externalValue);
  const focusedRef = useRef(false);

  useEffect(() => {
    if (!focusedRef.current) setLocal(externalValue);
  }, [externalValue]);

  return (
    <TextField
      {...props}
      value={local}
      onChange={(e) => setLocal(e.target.value)}
      onFocus={() => {
        focusedRef.current = true;
      }}
      onBlur={() => {
        focusedRef.current = false;
        if (local !== externalValue) onCommit(local);
      }}
    />
  );
});
